/* BLANK — motion + storefront behaviour. Ported from the design's DCLogic component. */
(function () {
  'use strict';
  var root = document.documentElement;
  // ?noprice=1 hides prices (used only for capturing promo footage)
  if (/[?&]noprice=1/.test(location.search)) root.classList.add('np');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isHome = document.body.classList.contains('is-home');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- preloader: the chase ----------------
     B sprints in from the left, K walks in from the right, they collide at 100%. */
  function preloader() {
    var pre = $('.pre');
    if (!pre) return;
    // already played this visit (or switched off): drop it without marking anything
    if (root.classList.contains('no-pre')) { pre.remove(); return; }
    var stage = $('.pre__stage', pre), b = $('[data-b]', pre), k = $('[data-k]', pre), pct = $('.pre__pct', pre);
    var teardown = function () {
      pre.classList.add('is-full');
      setTimeout(function () { pre.classList.add('is-fade'); }, reduced ? 600 : 1250);
      setTimeout(function () { pre.remove(); }, reduced ? 1200 : 1900);
    };
    try { sessionStorage.setItem('blank-pre', '1'); } catch (e) {}
    if (reduced) { teardown(); return; }
    var pose = function (p, ov, sq) {
      var w = stage.getBoundingClientRect().width || 170;
      var D = (Math.min(window.innerWidth, 1400) * 0.42) * (120 / w);
      var t = p / 100, kb = Math.pow(t, 1.7), kk = 1 - Math.pow(1 - t, 2.2);
      var lean = p < 100 ? -9 * (1 - kb) : 0;
      b.style.transform = 'translateX(' + (-D * (1 - kb) + ov) + 'px) skewX(' + lean + 'deg) scaleX(' + sq + ')';
      k.style.transform = 'translateX(' + (D * 0.62 * (1 - kk) - ov) + 'px)';
    };
    var done = false, raf, creep, t0 = performance.now(), RUN = 2000;
    var impact = function () {
      var s0 = performance.now();
      var step = function () {
        var s = Math.min(1, (performance.now() - s0) / 800);
        pose(100, Math.exp(-6 * s) * Math.cos(14 * s) * 22, 1 - 0.08 * Math.exp(-9 * s) * Math.max(0, 1 - Math.abs(1 - 2 * s)));
        if (s < 1) requestAnimationFrame(step);
      };
      step();
      setTimeout(teardown, 250);
    };
    var finish = function () {
      if (done) return; done = true; clearInterval(creep); cancelAnimationFrame(raf);
      pose(100, 0, 1); pct.textContent = '100%'; impact();
    };
    var advance = function () {
      if (done) return;
      var shown = Math.min(100, ((performance.now() - t0) / RUN) * 100);
      pose(shown, 0, 1);
      pct.textContent = Math.round(shown) + '%';
      if (shown >= 100) finish(); else raf = requestAnimationFrame(advance);
    };
    pose(0, 0, 1);
    advance();
    // belt and braces: a clamped timer in a hidden tab, plus an absolute force-finish
    creep = setInterval(advance, 250);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') advance(); });
    setTimeout(finish, 6000);
  }

  /* ---------------- header: glass past the hero, wordmark → monogram ---------------- */
  var head = $('.head'), mark = $('.mark');
  var state = { dark: false, past: false }, mk;
  function headerTick() {
    if (!head) return;
    var h = head.offsetHeight || 68;
    var dark = $$('[data-dark]').some(function (el) { var r = el.getBoundingClientRect(); return r.top < h && r.bottom > 0; });
    var past = window.scrollY > (isHome ? window.innerHeight * 0.75 : 140);
    if (dark !== state.dark) { state.dark = dark; head.classList.toggle('is-dark', dark); }
    if (past !== state.past) {
      state.past = past;
      head.classList.toggle('is-past', past);
      if (mark) {
        mark.dataset.phase = past ? 'play' : 'unplay';
        clearTimeout(mk);
        mk = setTimeout(function () { mark.dataset.phase = past ? 'mark' : 'word'; }, past ? 760 : 720);
      }
    }
  }

  /* ---------------- reveal: sections breathe in as they enter, settle back out as they leave ---------------- */
  var revealed = [];
  function setupReveal() {
    if (reduced) return;
    var vh = window.innerHeight || 800;
    var first = $('main > section:first-child, main > .shopify-section:first-child > *');
    $$('main > section, main > .shopify-section > section, main > .shopify-section > div > section, footer.foot').forEach(function (sec) {
      if (sec.hasAttribute('data-no-reveal') || sec === first) return;
      var kids = Array.prototype.slice.call(sec.children).filter(function (k) { return k.offsetHeight > 40; });
      if (sec.offsetHeight > vh * 1.1 && kids.length) revealed = revealed.concat(kids); else revealed.push(sec);
    });
    revealed.forEach(function (el) { el.setAttribute('data-reveal', ''); });
    revealTick();
  }
  function revealTick() {
    var vh = window.innerHeight || 800;
    revealed.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var inView = r.top < vh * 0.94 && r.bottom > vh * 0.04;
      if (inView) { if (el.style.opacity !== '1') { el.style.opacity = '1'; el.style.transform = 'none'; el.style.filter = 'none'; } }
      else if (el.style.opacity !== '0') { el.style.opacity = '0'; el.style.filter = 'blur(5px)'; el.style.transform = 'translateY(' + (r.top < 0 ? -26 : 40) + 'px)'; }
    });
  }

  var rafId = 0;
  function onScroll() {
    revealTick();
    if (rafId) return;
    rafId = requestAnimationFrame(function () { rafId = 0; headerTick(); revealTick(); });
  }

  /* ---------------- video: ambient loops autoplay muted; the brand film starts once in view and holds on the stitched wordmark ---------------- */
  function videos() {
    $$('video[data-ambient]').forEach(function (v) { v.muted = true; var p = v.play(); if (p) p.catch(function () {}); });
    $$('[data-film]').forEach(function (wrap) {
      var v = $('video', wrap), copy = $$('[data-film-copy]', wrap), replay = $('[data-film-replay]', wrap), ht;
      if (!v) return;
      var show = function (on) { wrap.classList.toggle('is-done', on); };
      var arm = function () { clearTimeout(ht); ht = setTimeout(function () { show(true); }, 6500); };
      v.muted = true;
      v.addEventListener('timeupdate', function () {
        var hold = parseFloat(wrap.dataset.hold || '3.6');
        if (v.duration && v.currentTime >= Math.min(hold, v.duration - 0.3) && !v.dataset.hold) { v.dataset.hold = '1'; v.pause(); show(true); }
      });
      v.addEventListener('ended', function () { show(true); });
      if (replay) replay.addEventListener('click', function () { delete v.dataset.hold; v.currentTime = 0; var p = v.play(); if (p) p.catch(function () {}); show(false); arm(); });
      if (reduced) { show(true); return; }
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting && !v.dataset.started) { v.dataset.started = '1'; var p = v.play(); if (p) p.catch(function () {}); arm(); io.disconnect(); }
      }, { threshold: 0.35 });
      io.observe(v);
    });
  }

  /* ---------------- hero slider: autoplay 4.5s, swipe resets the timer ---------------- */
  function heroSlider() {
    $$('[data-hero]').forEach(function (hero) {
      var sc = $('[data-hero-track]', hero), dots = $$('[data-hero-dot]', hero), n = dots.length, i = 0, prog = false, timer, hp;
      if (!sc || n < 2) return;
      var paint = function () { dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); }); };
      var go = function (to, smooth) {
        i = ((to % n) + n) % n; prog = true;
        sc.scrollTo({ left: sc.clientWidth * i, behavior: smooth === false || reduced ? 'auto' : 'smooth' });
        clearTimeout(hp); hp = setTimeout(function () { prog = false; }, 900); paint();
      };
      var start = function () { clearInterval(timer); if (!reduced) timer = setInterval(function () { go(i + 1); }, 4500); };
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); start(); }); });
      sc.addEventListener('scroll', function () {
        if (prog || !sc.clientWidth) return;
        var j = Math.round(sc.scrollLeft / sc.clientWidth);
        if (j !== i) { i = j; paint(); start(); }
      }, { passive: true });
      paint(); start();
    });
  }

  /* ---------------- carousels with prev/next ---------------- */
  function carousels() {
    $$('[data-carousel]').forEach(function (wrap) {
      var track = $('[data-carousel-track]', wrap);
      if (!track) return;
      var step = function (dir) { var c = track.firstElementChild; var w = c ? c.getBoundingClientRect().width + 16 : 300; track.scrollBy({ left: dir * w, behavior: reduced ? 'auto' : 'smooth' }); };
      $$('[data-prev]', wrap).forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
      $$('[data-next]', wrap).forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
    });
  }

  /* ---------------- mobile menu ---------------- */
  function menu() {
    var m = $('.mmenu');
    if (!m) return;
    var set = function (on) {
      m.classList.toggle('is-open', on); document.body.classList.toggle('menu-open', on);
      $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      if (on) { var x = $('.mmenu__x', m); if (x) x.focus(); }
    };
    $$('[data-menu-toggle]').forEach(function (b) { b.addEventListener('click', function () { set(!m.classList.contains('is-open')); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('is-open')) set(false); });
  }

  /* ---------------- toast ---------------- */
  var toastEl, toastT;
  function toast(text) {
    toastEl = toastEl || $('.toast');
    if (!toastEl) return;
    $('[data-toast-text]', toastEl).textContent = text;
    toastEl.classList.remove('is-on'); void toastEl.offsetWidth; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  window.BLANK = window.BLANK || {}; window.BLANK.toast = toast;

  /* ---------------- cart (AJAX) ---------------- */
  var routes = (window.BLANK_ROUTES || { cart_add: '/cart/add', cart: '/cart' });
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }
  function addToCart(items, label) {
    return fetch(routes.cart_add + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
      .then(function () { return fetch(routes.cart + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { setCount(cart.item_count); if (label) toast(label); return cart; })
      .catch(function (e) { toast(e.message); throw e; });
  }
  window.BLANK.addToCart = addToCart;

  /* Card / set / product forms: <form data-add> with variant picking from sizes (+ optional colour) */
  function variantFor(form) {
    var data = form.__variants || (form.__variants = JSON.parse(($('script[data-variants]', form) || {}).textContent || '[]'));
    var size = form.dataset.size, color = form.dataset.color;
    return data.find(function (v) { return (!size || v.size === size) && (!color || v.color === color); });
  }
  function adders() {
    $$('form[data-add]').forEach(function (form) {
      if (form.__bound) return; form.__bound = true;
      // size + colour chips
      $$('[data-pick-size]', form).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          form.dataset.size = btn.dataset.pickSize;
          $$('[data-pick-size]', form).forEach(function (b) { b.classList.toggle('is-on', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          refresh(form);
        });
      });
      refresh(form);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.dataset.size) { toast(form.dataset.needSize || 'Choose a size first'); return; }
        var items = [];
        if (form.hasAttribute('data-set')) {
          $$('script[data-set-variants]', form).forEach(function (s) {
            var vs = JSON.parse(s.textContent || '[]'); var v = vs.find(function (x) { return x.size === form.dataset.size; });
            if (v) items.push({ id: v.id, quantity: 1 });
          });
        } else { var v = variantFor(form); if (v) items.push({ id: v.id, quantity: 1 }); }
        if (!items.length) { toast('That size is not available'); return; }
        var btn = $('[data-add-btn]', form), idle = btn ? btn.innerHTML : '';
        if (btn) btn.disabled = true;
        addToCart(items, (form.dataset.label || 'Added') + ' · ' + form.dataset.size + ' added to bag').then(function () {
          if (form.hasAttribute('data-buy-now')) { window.location.href = '/checkout'; return; }
          if (btn) { btn.classList.add('is-on'); btn.textContent = form.dataset.addedLabel || 'Added to bag'; }
          setTimeout(function () { if (btn) { btn.classList.remove('is-on'); btn.innerHTML = idle; btn.disabled = false; refresh(form); } }, 1800);
        }).catch(function () { if (btn) { btn.innerHTML = idle; btn.disabled = false; } });
      });
    });
    $$('[data-buy-now-btn]').forEach(function (b) {
      b.addEventListener('click', function () { var f = b.closest('form'); f.setAttribute('data-buy-now', ''); f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true })); });
    });
  }
  function refresh(form) {
    var btn = $('[data-add-btn]', form);
    var priceEl = $('[data-price]', form);
    if (form.hasAttribute('data-set') || !btn || !form.hasAttribute('data-pdp')) return;
    var v = variantFor(form);
    if (form.dataset.soldout === 'true') return;
    if (!form.dataset.size) { btn.textContent = 'Select a size'; return; }
    btn.textContent = v && v.available ? 'Add to bag · ' + v.price : 'Sold out';
    btn.disabled = !(v && v.available);
    var hint = $('[data-size-hint]', form); if (hint) hint.textContent = '· ' + form.dataset.size;
    if (priceEl && v) priceEl.textContent = v.price;
  }

  /* ---------------- colour swatches on cards: swap the whole card to the sibling colour in place ---------------- */
  function swatches() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-swap]');
      if (!b) return;
      var card = b.closest('[data-card]');
      if (!card) return;
      e.preventDefault();
      card.style.opacity = '.55';
      fetch(b.dataset.swap + '?view=card').then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html.trim();
        var next = tmp.querySelector('[data-card]');
        if (!next) { card.style.opacity = ''; return; }
        next.className = card.className;
        next.setAttribute('style', card.dataset.baseStyle || '');
        next.dataset.baseStyle = card.dataset.baseStyle || '';
        var ri = revealed.indexOf(card);
        if (ri > -1) { revealed[ri] = next; next.setAttribute('data-reveal', ''); }
        card.replaceWith(next);
        revealTick();
        adders();
        var on = next.querySelector('.sw.is-on'); if (on) on.focus();
      }).catch(function () { card.style.opacity = ''; });
    });
  }

  /* ---------------- quick view ---------------- */
  function quickView() {
    var qv = $('.qv');
    if (!qv) return;
    var close = function () { qv.classList.remove('is-open'); qv.innerHTML = ''; };
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quick]');
      if (b) {
        e.preventDefault();
        fetch(b.dataset.quick + (b.dataset.quick.indexOf('?') > -1 ? '&' : '?') + 'view=quick').then(function (r) { return r.text(); }).then(function (html) {
          qv.innerHTML = html; qv.classList.add('is-open'); adders(); var x = $('[data-qv-close]', qv); if (x) x.focus();
        });
        return;
      }
      if (e.target === qv || e.target.closest('[data-qv-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qv.classList.contains('is-open')) close(); });
  }

  /* ---------------- offline: "one thread, cut" ---------------- */
  function offline() {
    var sys = $('.sys');
    if (!sys) return;
    window.addEventListener('offline', function () { sys.classList.add('is-on'); });
    window.addEventListener('online', function () { sys.classList.remove('is-on'); });
    $$('[data-sys-retry]', sys).forEach(function (b) { b.addEventListener('click', function () { if (navigator.onLine) sys.classList.remove('is-on'); }); });
  }

  /* ---------------- accordions / tabs (generic toggles) ---------------- */
  function toggles() {
    $$('[data-acc]').forEach(function (grp) {
      $$('[data-acc-btn]', grp).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-acc-item]'), open = item.classList.contains('is-open');
          $$('[data-acc-item]', grp).forEach(function (it) { it.classList.remove('is-open'); $('[data-acc-btn]', it).setAttribute('aria-expanded', 'false'); var s = $('[data-sign]', it); if (s) s.textContent = '+'; });
          if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); var s = $('[data-sign]', item); if (s) s.textContent = '−'; }
        });
      });
    });
    $$('[data-toggle]').forEach(function (btn) {
      var target = document.getElementById(btn.dataset.toggle);
      if (!target) return;
      btn.addEventListener('click', function () { var on = target.hidden; target.hidden = !on; btn.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    });
  }

  /* ---------------- boot ---------------- */
  preloader();
  menu(); adders(); swatches(); quickView(); offline(); toggles(); heroSlider(); carousels();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  var boot = function () { headerTick(); setupReveal(); videos(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { revealed = []; setupReveal(); heroSlider(); carousels(); videos(); adders(); });
})();
